/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";

import { useEffect } from "react";
import AccountName from "../../../../../components/_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../../components/_utils/AccountCreationComponents/ContactDetails";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import SVGComponent from "../../../../../components/_utils/SVGComponent";
import {
  editInternal,
  resetEditInternalData,
  viewInternalAccountDetail,
} from "../../../../../redux/features/internalApi/internalApi";
import TEXT from "../../../../../utils/globalText";
import Validation from "../../../../../utils/validation";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";

const InternalContactEdit = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [customErrors, setCustomErrors] = useState({});
  const [selectedValue, setSelectedValue] = useState("");
  const [emailValidation, setEmailValidation] = useState(false);
  const [nextButtonEnabled, setNextButtonEnabled] = useState(true);
  const [openEditContactPop, setOpenEditContactPop] = useState(false);
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [contactNumberValidation, setContactNumberValidation] = useState(false);
  const [payload, setPayload] = useState({
    contact_no: "",
    email_id: "",
    account_name: "",
    legalName: "",
  });

  const [updateActive, setUpdateActive] = useState(false);

  const {
    viewInternalAccountDetailData,
    viewInternalAccountDetailLoading,
    editInternalData,
  } = useSelector((state) => state.internalAcc);

  const internalAccountData =
    viewInternalAccountDetailData?.internal_accounts[0];

  const { services, isLoading } = useSelector((state) => state.refreshToken);
  useEffect(() => {
    const fetchContactData = async () => {
      let response = await dispatch(viewInternalAccountDetail({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchContactData();
  }, [dispatch, id, navigate]);

  const check = internalAccountData?.contact_no !== payload.contact_no;

  const handleBack = () => {
    if (!nextButtonEnabled) {
      setOpenEditContactPop(true);
    } else {
      navigate(-1);
    }
  };

  const handleRadioBtn = (event) => {
    setSelectedValue(event.target.value);
    handleUpdateLegalName(event.target.value);
  };
  const handleDivBtn = (value) => {
    setSelectedValue(value);
    handleUpdateLegalName(value);
  };

  useEffect(() => {
    if (
      !viewInternalAccountDetailLoading &&
      viewInternalAccountDetailData?.status === true
    ) {
      const internalData = viewInternalAccountDetailData?.internal_accounts[0];

      if (internalData) {
        setPayload((prevPayload) => ({
          ...prevPayload,
          contact_no: internalData.contact_no,
          email_id: internalData.email_id,
          account_name: internalData.name,
          legalName: internalData.pan_legal_name,
        }));
      }
      if (internalData?.pan_legal_name === internalData?.name) {
        setSelectedValue("legalname");
      } else {
        setSelectedValue("customname");
      }
    }
  }, [
    viewInternalAccountDetailData,
    viewInternalAccountDetailLoading,
    dispatch,
  ]);

  useEffect(() => {
    setContactNumberValidation(
      Validation.allowedContactNum(payload.contact_no),
    );
    setEmailValidation(Validation.allowedEmail(payload.email_id));
  }, [payload.contact_no, payload.email_id]);

  const emailRegex = /^[\w.-]+@([\w-]+\.)+[A-Za-z]{2,}$/;

  const modifyValue = (type, value) => {
    if (type === "gstin") {
      return value?.toUpperCase();
    } else if (type === "account_name" || type === "name") {
      return value;
    } else {
      return value.trim();
    }
  };

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);

    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);
    if (name === "account_name")
      errors = Validation.validateAccountName(name, value, errors);
    setCustomErrors(errors);
  };

  const checkAllValidations = () => {
    return contactNumberValidation && emailValidation;
  };

  const handleUpdateLegalName = (value) => {
    const internalData = viewInternalAccountDetailData?.internal_accounts?.[0];

    setPayload((prevPayload) => {
      if (value === "legalname") {
        return {
          ...prevPayload,
          account_name: internalData?.pan_legal_name || "",
        };
      }

      if (value === "customname") {
        const keepCurrent =
          prevPayload.account_name &&
          prevPayload.account_name.trim().length > 0 &&
          prevPayload.account_name.trim().toLowerCase() !==
            (internalData?.pan_legal_name || "").trim().toLowerCase();

        return {
          ...prevPayload,
          account_name: keepCurrent
            ? prevPayload.account_name
            : internalData?.name || "",
        };
      }

      return prevPayload;
    });
  };

  useEffect(() => {
    if (
      !viewInternalAccountDetailLoading &&
      viewInternalAccountDetailData?.status === true
    ) {
      const internalData = viewInternalAccountDetailData?.internal_accounts[0];
      if (
        internalData?.contact_no !== payload.contact_no ||
        internalData?.email_id !== payload.email_id.toLowerCase() ||
        (internalData?.name.trim() !== payload.account_name.trim() &&
          payload.account_name.length !== 0)
      ) {
        if (
          !(checkAllValidations() && payload.email_id?.length !== 0) ||
          !(checkAllValidations() && payload.contact_no?.length !== 0) ||
          !payload.account_name.trim().length > 0
        ) {
          setNextButtonEnabled(true);
        } else {
          setNextButtonEnabled(false);
        }
      } else {
        setNextButtonEnabled(true);
      }
    }
  }, [payload.account_name, payload.contact_no, payload.email_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(
      name,
      name !== "account_name" ? value.replace(/[^a-zA-Z0-9@.]/g, "") : value,
    );

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (value.trim() === "" && value.length === 1) {
        return;
      }
      if (name === "contact_no") {
        if (
          name === "contact_no" &&
          (newValue.length === 0 || newValue.length < 10)
        ) {
          setContactNumberValidation(false);
        } else {
          setContactNumberValidation(true);
        }
      }
      if (name === "email_id") {
        if (
          name === "email_id" &&
          (newValue.length === 0 || !emailRegex.test(newValue))
        ) {
          setEmailValidation(false);
        } else {
          setEmailValidation(true);
        }
      }
      if (name === "account_name") {
        if (name === "account_name" && newValue.length === 0) {
          setAccountNameValidation(false);
        } else {
          setAccountNameValidation(true);
        }
        if (
          newValue ===
          viewInternalAccountDetailData?.internal_accounts[0]?.pan_legal_name
        ) {
          setSelectedValue("legalname");
        }
      }
    }
  };

  useEffect(() => {
    if (customErrors["contact_no"]) setContactNumberValidation(false);
    if (!customErrors["contact_no"] && payload.contact_no?.length === 10)
      setContactNumberValidation(true);
    if (customErrors["email_id"]) setEmailValidation(false);
    if (
      !customErrors["email_id"] &&
      payload.email_id?.length > 0 &&
      emailRegex.test(payload.email_id)
    )
      setEmailValidation(true);
    if (customErrors["account_name"]) setAccountNameValidation(false);
    if (!customErrors["account_name"] && payload.account_name.length > 0)
      setAccountNameValidation(true);
  }, [customErrors]);

  useEffect(() => {
    if (editInternalData?.status === true) {
      const updatedFields = [];

      if (internalAccountData?.contact_no !== payload.contact_no) {
        updatedFields.push("contact_no");
      }
      if (
        (internalAccountData?.email_id || "").toLowerCase().trim() !==
        (payload.email_id || "").toLowerCase().trim()
      ) {
        updatedFields.push("email_id");
      }
      if (
        (internalAccountData?.name || "").trim() !==
        (payload.account_name || "").trim()
      ) {
        updatedFields.push("account_name");
      }
      navigate(
        `/internal_account_dashboard/view_details/contact_edit_success/${id}`,
        {
          state: {
            updatedFields:
              updatedFields.length > GlobalConfiguration.lengthCheckZero
                ? updatedFields
                : ["contact_no", "email_id", "account_name"],
          },
        },
      );

      dispatch(resetEditInternalData());
    }
  }, [editInternalData]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("IUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "IUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      stepperText: "Contact details",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: !nextButtonEnabled
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextIsEnabled: !nextButtonEnabled,
      nextIsLoading: updateActive,
      nextLoaderNeeded: true,
      nextHoverOption: "black",
    },
  ];

  const handleUpdateAccount2 = async () => {
    if (updateActive) return;

    setUpdateActive(true);

    try {
      await dispatch(
        editInternal({
          id: id,
          email: payload?.email_id?.toLowerCase(),
          contact_no: payload.contact_no,
          name: payload?.account_name,
          navigate,
        }),
      ).unwrap();

      dispatch(resetEditInternalData());
    } catch (error) {
      console.error("Update failed:", error);
    } finally {
      setUpdateActive(false);
    }
  };

  const handleConfirm = () => {
    navigate(
      `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${id}`,
    );
  };

  return (
    <>
      <div className=" bg-primary-bg flex overflow-y-hidden flex-col h-full-height">
        <div className="min-h-navbar-breadcrumb-height hidden Qmd:block"></div>
        <div
          className="max-w-tab-width-normal  w-full flex flex-col justify-start items-center mx-auto my-margin-base"
          style={{
            overflow: !nextButtonEnabled && openEditContactPop ? "hidden" : "",
          }}
        >
          {!nextButtonEnabled && openEditContactPop && (
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <SmallPopup
                headerTitle={TEXT.LEAVE_PAGE_WARNING_HEADER}
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                subtext={TEXT.LEAVE_PAGE_WARNING_MSG_EDIT_CONTACT}
                btnOneText="Cancel"
                btnOneBtnType="button"
                btnOneEnabledBgColor="transparent"
                btnOneHandleFunction={() => setOpenEditContactPop(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneIsDisabled={false}
                btnOneHoverOption="white"
                btnTwoText="Leave"
                btnTwoBtnType="button"
                btnTwoHandleFunction={handleConfirm}
                btnTwoEnabledBgColor="var(--text-primary)"
                btnTwoEnabledTextColor="var(--primary-bg)"
                btnTwoIsDisabled={false}
                btnTwoHoverOption="black"
              />
            </div>
          )}
          <div className=" min-h-stepper-height Qmd:relative flex justify-center bottom-bottom-base items-end fixed Qmd:top-top-base   left-left-base w-width-full z-z-index-header">
            <PrimaryStepper
              activeStep={0}
              handleForwardAction={handleUpdateAccount2}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
          <div className="bg-primary-nav mt-margin-base fixed top-top-base left-left-base w-full z-z-index-header">
            <div className="h-navbar-height bg-primary-nav fixed top-top-base w-width-full flex items-center z-z-index-header shadow-box-shadow-bottom">
              <div
                className="w-icon-sm h-icon-sm m-margin-md cursor-pointer"
                onClick={() => handleBack()}
              >
                <SVGComponent
                  url="https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
                  height="var(--icon-sm)"
                  width="var(--icon-sm)"
                  color="var(--text-primary)"
                  alt="arrow left"
                />
              </div>
              <div className="py-padding-sm">
                <p className="text-text-primary text-font-md">
                  {TEXT.EDIT_INTERNAL_ACCOUNT}
                </p>
                <p className="text-text-secondary text-font-xs">
                  {TEXT.ENTER_CONTACT_DETAILS}
                </p>
              </div>
            </div>
          </div>

          <div className="h-navbar-height block Qmd:hidden"></div>
        </div>

        <div className="flex flex-row h-full-height max-w-tab-width-normal mx-auto w-full flex-1">
          <div className=" w-full ">
            <div className="w-width-full px-padding-md lg:px-padding-base Qmd:gap-gap-md flex flex-col Qmd:flex-row h-fit pb-padding-md">
              <div
                className={`flex flex-col relative w-full rounded-border-radius-md mb-margin-md pt-padding-lg`}
              >
                <AccountName
                  handleChange={handleChange}
                  accountNameValidation={accountNameValidation}
                  accountName={payload.account_name}
                  selectedValue={selectedValue}
                  handleDivBtn={handleDivBtn}
                  handleRadioBtn={handleRadioBtn}
                  selectedRadioValue={selectedValue}
                  legalName={payload?.legalName}
                  placeHolder="Name"
                />
              </div>
              <div
                className={`flex flex-col relative rounded-border-radius-md w-full mb-margin-md  pt-padding-md  Qmd:pt-padding-lg`}
              >
                <ContactDetails
                  handleChange={handleChange}
                  contactNumberValidation={contactNumberValidation}
                  emailValidation={emailValidation}
                  contactNumber={payload.contact_no}
                  emailId={payload.email_id}
                  selectedValue={selectedValue}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InternalContactEdit;
